// extracted by mini-css-extract-plugin
export default {"container":"ContentTitle_container__-0+H6","title":"ContentTitle_title__KtykG","count":"ContentTitle_count__Pnspf"};